export default __webpack_public_path__ + "static/media/takeaway.bf14e372.svg";